import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-gallerySlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			var slider = new Swiper (el.querySelector('.b-gallerySlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 16,
				watchOverflow: false,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				slideClass: 'b-gallerySlider-item',
				navigation : {
					nextEl : el.querySelector('.b-sliderArrows-btn_next'),
					prevEl : el.querySelector('.b-sliderArrows-btn_prev')
				},
				breakpoints: {
					1380: {
						spaceBetween: 40,
					},
				},
			});
		});
	});
});
